import axios from 'axios'

// Cors Header
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// const site = 'http://localhost:3000'
const site = 'https://admin.atlanticprints.com'
// const site = 'https://atl-prints-staging.herokuapp.com'
const base = 'api'
const endpoint = (resource) => `${site}/${base}/${resource}`

/**
 * Wrapper for axios.
 * @param {string} action   - Action for axios
 * @param {string} resource - Endpoint to use
 * @param {(* | null)} [payload = null] - Data to post
 * @param {(* | null)} [config = null] - Config Axios
 */
export async function fetch(action, resource, payload = null, config = null) {
  const { data } = await axios[action](resource, payload, config)
  return data
}

export default {
  async getStart() {
    return fetch('get', endpoint('start'))
  },
  async getAvailability() {
    return fetch('get', endpoint('availability'))
  },
  async postAppointment(payload) {
    return fetch('post', endpoint('appointments'), payload)
  }
}
